import { Grid, LinearProgress, Typography } from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector, Field } from 'redux-form'
import { CloseDialog } from '../../../../actions/types'
import { DialogButtons } from '../../../../components/Buttons'
import SubmitFormButton from '../../../../components/Buttons/SubmitFormButton'
import ErrorMessage from '../../../../components/Error/ErrorMessage'
import { ReduxComboBox } from '../../../../components/FormInput/ReduxWrappers'
import { objectNotEmpty } from '../../../../libs/objects'
import { UpdateApartmentUserIdProps } from '../../../../types/apartments'
import { AutocompleteOption } from '../../../../types/autocomplete'
import { ReduxForm } from '../../../../types/forms'
import {
  StateInterface,
  IndexedUsersState,
  UserIdIndex
} from '../../../../types/states'
import { UserInterface } from '../../../../types/users'

const selector = formValueSelector('UpdateUserIdForm')

const mapStateToProps = (state: StateInterface) => ({
  newUserId: selector(state, 'newUserId') as string | undefined
})

type StateProps = ReturnType<typeof mapStateToProps>

interface OwnProps {
  updateApartmentUserId: (props: UpdateApartmentUserIdProps) => void
  closeDialog: CloseDialog
  indexedUsers: IndexedUsersState
  userOptions: AutocompleteOption[]
  t: TFunction
}

type UpdateUserIdFormProps = StateProps & OwnProps & ReduxForm

const UpdateUserIdForm: FC<UpdateUserIdFormProps> = ({
  updateApartmentUserId,
  t,
  handleSubmit,
  submitting,
  error,
  userOptions,
  closeDialog,
  indexedUsers,
  newUserId
}) => (
  <form onSubmit={handleSubmit(updateApartmentUserId)}>
    <Grid container direction='column' spacing={1}>
      <Field
        required
        name='newUserId'
        label={t('updateApartmentUserId.dialog.selectField')}
        component={ReduxComboBox}
        options={userOptions}
      />
      {newUserId && objectNotEmpty<UserIdIndex>(indexedUsers) && (
        <Typography variant='body1' style={{ paddingTop: '25px' }}>
          {t('updateApartmentUserId.dialog.confirm', {
            ownerName: indexedUsers[newUserId]
              ? (indexedUsers[newUserId] as UserInterface)?.data?.name ||
                'Not found'
              : 'Not found'
          })}
        </Typography>
      )}
      <ErrorMessage error={error} />
      {submitting && <LinearProgress />}
      <DialogButtons
        closeDialog={closeDialog}
        dialogName='UpdateApartmentUserId'
        ButtonTwo={
          <SubmitFormButton
            textColor='white'
            variant='contained'
            disabled={!newUserId && objectNotEmpty<UserIdIndex>(indexedUsers)}
            submitting={submitting}
            label='general.confirm'
          />
        }
      />
    </Grid>
  </form>
)

interface UpdateUserIdFormData {
  newUserId: string | undefined
}

export default connect<
  StateProps,
  Record<string, unknown>,
  OwnProps,
  StateInterface
>(mapStateToProps)(
  reduxForm<UpdateUserIdFormData, OwnProps & UpdateUserIdFormData, string>({
    form: 'UpdateUserIdForm'
  })(UpdateUserIdForm)
)
